import { api, unwrap, type APIResponse, type Paginated } from "./client";

// Mirrors app/routers/consent.py.
export interface ConsentTemplate {
  consent_template_id: number;
  name: string;
  body: string;
  is_active: boolean;
  created_at: string | null;
}

export interface ConsentTemplateInput {
  name: string;
  body: string;
  is_active?: boolean;
}

export interface ConsentLogEntry {
  consent_send_log_id: number;
  sent_by_kind: string;
  to_number: string;
  from_number: string;
  body: string;
  status: string;
  error: string | null;
  template_id: number | null;
  provider_message_id: string | null;
  created_at: string | null;
}

export async function listConsentTemplates(includeInactive = false): Promise<ConsentTemplate[]> {
  const resp = await api.get<APIResponse<ConsentTemplate[]>>("/consent/templates", {
    params: includeInactive ? { include_inactive: true } : {},
  });
  return unwrap(resp.data);
}

export async function createConsentTemplate(body: ConsentTemplateInput): Promise<ConsentTemplate> {
  const resp = await api.post<APIResponse<ConsentTemplate>>("/consent/templates", body);
  return unwrap(resp.data);
}

export async function updateConsentTemplate(id: number, body: ConsentTemplateInput): Promise<ConsentTemplate> {
  const resp = await api.patch<APIResponse<ConsentTemplate>>(`/consent/templates/${id}`, body);
  return unwrap(resp.data);
}

export async function deleteConsentTemplate(id: number): Promise<void> {
  await api.delete(`/consent/templates/${id}`);
}

// Agents omit `to` — the backend sends to their current caller. Operators pass `to`.
export async function sendConsent(body: { template_id: number; to?: string; spool_id?: number }): Promise<{ status: string; to: string; provider_message_id: string | null }> {
  const resp = await api.post<APIResponse<{ status: string; to: string; provider_message_id: string | null }>>("/consent/send", body);
  return unwrap(resp.data);
}

export async function listConsentLog(page = 1, perPage = 50): Promise<Paginated<ConsentLogEntry>> {
  const resp = await api.get<Paginated<ConsentLogEntry>>("/consent/log", { params: { page, per_page: perPage } });
  return resp.data;
}
